// @flow
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'redux-first-history'
import { not } from 'ramda'

import { changeGuestAccessTTL } from '@alphaott/app-core/actions'
import { getCustomerGuestMode, getGuestAccessTrialExpires } from '@alphaott/app-core/selectors'
import { useGuestAccess } from '@alphaott/guest-access/hooks'

type GuestCustomerProps = {
  children: any,
}

type GuestCustomerModeProps = GuestCustomerProps & {}

const GuestAccessMode = ({ children }: GuestCustomerModeProps) => {
  const dispatch = useDispatch()

  useGuestAccess({
    onExpire: () => dispatch(push('/error')),
  })

  return children
}

export const GuestAccess = ({ children }: GuestCustomerProps) => {
  const dispatch = useDispatch()

  const isGuestCustomer = useSelector(getCustomerGuestMode)
  const trialExpires = useSelector(getGuestAccessTrialExpires)

  // Reset ttl for customer without guestMode flag
  useEffect(() => {
    if (trialExpires && not(isGuestCustomer)) {
      dispatch(changeGuestAccessTTL({ expires: 0 }))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Customer with guestMode flag
  if (isGuestCustomer) {
    return <GuestAccessMode>{children}</GuestAccessMode>
  }

  // Customer without guestMode flag
  return children
}

export default GuestAccess
